<template>
  <div id="timeline">
    <div class="time-marker" id="first-marker">
      <div class="circle"></div>
      <span>15,000 years ago</span>
    </div>
    <div class="time-marker" id="wildlife-marker">
      <div class="circle"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Timeline',
}
</script>
<style>
#timeline {
  width: 3670px;
  height: 1.5px;
  background-color: var(--timeline-green);
  position: absolute;
  left: 605px;
  bottom: 50%;
}
#timeline #first-marker {
  left: 550px;
}
#timeline #first-marker .circle {
  border: 1.5px solid var(--hydrology-blue-outline);
  background-color: var(--hydrology-blue);
}
#timeline #wildlife-marker {
  left: 2100px;
}
#timeline #wildlife-marker .circle {
  border: 1.5px solid var(--wildlife-green-outline);
  background-color: var(--wildlife-green);
}
</style>
